import {CommonModule, LowerCasePipe} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {JwtModule} from '@auth0/angular-jwt';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {RxStompService} from '@stomp/ng2-stompjs';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {SharedModule} from '../shared/shared.module';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {HeaderComponent} from './components/header/header.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {AuthService} from './services/auth-service.service';
import {HeadersInterceptorService} from './services/headers-interceptor.service';
import {JwtInterceptorService} from './services/jwt-interceptor.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input-gg';
import {TranslateModule} from '@ngx-translate/core';

export function jwtTokenGetter() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [HeaderComponent, NavbarComponent, BreadcrumbComponent],
    imports: [
        CommonModule,
        RouterModule,
        BrowserAnimationsModule,
        SharedModule,
        BsDropdownModule.forRoot(),
        HttpClientModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: jwtTokenGetter
            }
        }),
        FontAwesomeModule,
        FormsModule,
        LowerCasePipe,
        NgSelectModule,
        NgxIntlTelInputModule,
        ReactiveFormsModule,
        TranslateModule
    ],
  exports: [
    HeaderComponent,
    NavbarComponent,
    BreadcrumbComponent
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptorService,
      multi: true
    },
    RxStompService,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parent: CoreModule) {
    if (parent) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
